import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FileItem, FileType } from '../models/file-item.model';
import { ConfigParserService } from './config-parser.service';

export interface WebManifest {
    name: string;
    short_name: string;
    start_url: string;
    scope: string;
    display: string;
    orientation: string;
    icons: Array<WebManifestIcons>;
    background_color: string;
    theme_color: string;
}

export interface WebManifestIcons {
    src: string;
    sizes: string;
    type: string;
}

@Injectable({
    providedIn: 'root'
})
export class WebPwaService {
    public readonly isStandalone: Observable<boolean>;

    private readonly manifestData: WebManifest;

    constructor(
        configParserService: ConfigParserService,
        private readonly breakpointObserver: BreakpointObserver
    ) {
        this.manifestData = configParserService.parse<WebManifest>('webManifestConfig') || {
            name: null,
            short_name: null,
            start_url: null,
            scope: null,
            display: null,
            orientation: null,
            icons: [],
            background_color: null,
            theme_color: null
        };

        this.isStandalone = this.breakpointObserver.observe('(display-mode: standalone)').pipe(map(res => res.matches));
    }

    public getManifestFileType(): FileType {
        return FileItem.fileTypeNameToFileType(this.manifestData.short_name);
    }

    public isOfficeApp(): boolean {
        return this.manifestData.name === 'Office';
    }

    public hasManifest(): boolean {
        return !!this.manifestData.name;
    }
}
